import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'striphtml'})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
    return value ? value.replace(/<.*?>/g, '').replace(/&\w+;/g, '') : value;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/pipes/striphtml.ts